export default "__VITE_PUBLIC_ASSET__1e806b4e__"